import React from 'react'
import MessageProvider from '@packages/justo-parts/lib/components/Provider/Message'
import ApolloServicesClients from '@providers/apollo/ApolloServicesClients'
import {GlobalState} from '@providers/GlobalState'
import MobileOrDesktopContext from '@providers/MobileOrDesktopContext'
import Session from '@providers/Session'
import WebsiteIdContext from '@providers/WebsiteIdContext'
import dynamic from 'next/dynamic'

import '@providers/locale'

const NonSsrRoot = dynamic(() => import('./NonSsrRoot'), {ssr: false})

export default function Root({
  children,
  pageProps,
  websiteId
}: {
  children: React.ReactNode
  pageProps: any
  websiteId?: string
}) {
  return (
    <GlobalState>
      <MobileOrDesktopContext.Provider value={pageProps.mobileOrDesktop}>
        <WebsiteIdContext.Provider value={websiteId}>
          <MessageProvider>
            <ApolloServicesClients>
              <Session>
                <NonSsrRoot pageProps={pageProps} />
                {children}
              </Session>
            </ApolloServicesClients>
          </MessageProvider>
        </WebsiteIdContext.Provider>
      </MobileOrDesktopContext.Provider>
    </GlobalState>
  )
}
